
import Component from "vue-class-component"
import {Inject} from "vue-property-decorator"
import {DateRangeService} from "@/DateRangeService"
import SankeyDiagram from "@/ui/chart/SankeyDiagram.vue"
import PageHeader from "@/superannuation/PageHeader.vue"
import HelpIcon from "@/ui/HelpIcon.vue"
import SuperScoreStar from "@avantek/commons-js/superscore/SuperScoreStar/SuperScoreStar.vue"
import {MetricStore} from "@/cube/metric-data/MetricStore"
import {PlanService} from "@/superannuation/PlanService"
import {WithAnalyticsNavigation} from "@/superannuation/WithAnalyticsNavigation"
import DetailPage from "@/superannuation/DetailPage.vue"
import ChangeRateWidget from "@/superannuation/ChangeRateWidget.vue"
import SuperScoreStarComponentWidget from "@/components/dashboard/SuperScoreStarComponentWidget.vue"
import {SuperScoreArea} from "@/superscore/SuperScoreArea"

@Component({
  components: {
    SuperScoreStarComponentWidget,
    ChangeRateWidget,
    DetailPage,
    SankeyDiagram,
    PageHeader,
    HelpIcon,
    SuperScoreStar: <any>SuperScoreStar,
  },
})
export default class SuperScoreView extends WithAnalyticsNavigation {
  @Inject()
  dateRangeService: DateRangeService

  @Inject()
  planService: PlanService

  metricStore: MetricStore

  SuperScoreArea = SuperScoreArea

  async created() {
    this.metricStore = new MetricStore()
  }
}
